import * as React from "react";
import type { SVGProps } from "react";
const SvgMailIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="mail_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M213.333 170.667a128 128 0 0 0-128 128v426.666a128 128 0 0 0 128 128h597.334a128 128 0 0 0 128-128V298.667a128 128 0 0 0-128-128H213.333zm-42.666 138.666 315.477 236.63c15.36 11.477 36.395 11.477 51.712 0l315.477-236.63v416A42.667 42.667 0 0 1 810.667 768H213.333a42.667 42.667 0 0 1-42.666-42.667v-416zM782.208 256 512 458.667 241.792 256h540.416z"
    />
  </svg>
);
export default SvgMailIcon;
